export const defaultFlags = {
    oiLicenseManagement : false,
    licenseBundlesV2 : false,
    ossAgreementVerification: false,
}
    